import { useQuery } from "@tanstack/react-query";

import { getOrganizationDepartmentsOptions } from "@/openapi/@tanstack/react-query.gen";

export const useOrganizationDepartments = ({
  id,
  enabled = true,
}: {
  id: string;
  enabled?: boolean;
}) => {
  const departments = useQuery({
    ...getOrganizationDepartmentsOptions({ path: { org_id: id } }),
    enabled: !!id && enabled,
  });

  return departments;
};
